var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImputbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8363 21.9707L11.7634 22.0438L11.7634 22.1471L11.7634 24L11.7634 24.6043L12.1904 24.1766L20.177 16.1766L20.3533 16L20.177 15.8234L12.1904 7.82337L11.7634 7.39573L11.7634 8L11.7634 9.5L11.7634 9.59919L11.8314 9.6714L17.7872 15.9951L11.8363 21.9707Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImputbar);
export default __webpack_public_path__ + "static/media/icon-imputbar.f957878b3b18fe1a32526e5e9e9e3f8b.svg";
export { ForwardRef as ReactComponent };